<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("bank") }}</div>
      <router-link
        v-if="$can('create', 'Bank')"
        class="btn-blue"
        to="add-bank"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getBankList"
          v-model="searchValue"
          :placeholder="$tc('searchs')"
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              getBankList(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'bank_name'"
                @click="onSortValue('bank_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('bank_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('bank_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("bank") }} {{ $t("name") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'country_name'"
                @click="onSortValue('country_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('country_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('country_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("country") }}
            </th>
          </tr>
        </thead>
        <tbody v-if="bankname.length > 0">
          <tr v-for="(bank, bankIndex) in bankname" :key="bankIndex">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    bank.bank_is_active === 'Y'
                      ? 'active'
                      : bank.bank_is_active === 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Bank')"
                    v-on:click="onEditBank(bank)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewBank(bank)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    bank.bank_is_active === 'Y'
                      ? 'active'
                      : bank.bank_is_active === 'N' && 'inactive'
                  "
                />

                <i
                  v-if="$can('update', 'Bank')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  @click.prevent.stop="onEditBank(bank)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>
                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  @click.prevent.stop="onViewBank(bank)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>
            <td>{{ bank.bank_name }}</td>
            <td>{{ bank.country_name }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="bankname.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      bank_id: "",
      bankname: [],
      banks: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getBankList();
  },
  mounted() {},
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getBankList();
    },
    getBankList(filterIsActive = "Y") {
      this.bankname = [];
      MarketingService.getAllBank(
        this.perPage,
        this.currentPage,
        this.columnName,
        this.orderby,
        this.searchValue,
        filterIsActive
      ).then((response) => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0) {
            this.bankname = data.Records;
            this.rows = data.totalCount;
            if (this.rows <= this.selectedvalue) {
            }
          }
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    onViewBank: function (bank) {
      this.$router.push({
        path: "/marketing/view-bank",
        query: { bank_id: bank.bank_id },
      });
    },
    onEditBank: function (bank) {
      this.$router.push({
        path: "/marketing/edit-bank",
        query: { bank_id: bank.bank_id },
      });
    },

    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getBankList();
      } else {
        this.currentPage = event;
        this.getBankList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/bankComponents/bank.vue